import { BookOpenCheck, MapPin, ShieldCheck } from "lucide-react";
const trustBadges = [{
  icon: ShieldCheck,
  text: "NDIS Provider-Ready Resources"
}, {
  icon: BookOpenCheck,
  text: "Research-Backed"
}, {
  icon: MapPin,
  text: "Australian Focused"
}];
export default function YourTrustedVoiceForPda() {
  return <section id="your-trusted-voice-for-pda" className="bg-background py-20 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        
        {}
        <div className="lg:col-span-5 relative">
          <div className="relative z-10 rounded-[2rem] overflow-hidden shadow-2xl shadow-primary/5 border border-border/50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559791/img/pda_australia_team_classroom.png" alt="PDA Australia Team in a supportive classroom setting" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square lg:aspect-[4/5]" />
          </div>
          {}
          <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-secondary/40 rounded-full blur-3xl -z-10"></div>
          <div className="absolute -top-8 -right-8 w-48 h-48 bg-primary/10 rounded-full blur-3xl -z-10"></div>
        </div>

        {}
        <div className="lg:col-span-7 flex flex-col justify-center">
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-8 tracking-tight">
            Our Mission
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl font-sans text-foreground/80 leading-relaxed mb-12">
            <p>
              At PDA Australia, we are dedicated to providing a compassionate, authoritative, and trustworthy source of information about Pathological Demand Avoidance (PDA) for families and educators across the country.
            </p>
            <p>
              We understand the unique challenges faced by individuals with a PDA profile of autism. Our goal is to bridge the gap in understanding by publishing expert articles, offering tailored resources, and creating a supportive community.
            </p>
            <p>
              Whether you are a parent seeking guidance on NDIS support pathways or a teacher looking for practical classroom strategies, we are here to empower you with research-backed, easy-to-use downloadable guides.
            </p>
          </div>

          {}
          <div className="flex flex-col sm:flex-row flex-wrap gap-6 sm:gap-8 pt-8 border-t border-border/60">
            {trustBadges.map((badge, i) => {
            const Icon = badge.icon;
            return <div key={i} data-index={i} className="flex items-center gap-4">
                  <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-2xl bg-primary/10 text-primary">
                    <Icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <span className="font-sans font-semibold text-foreground text-base md:text-lg leading-tight max-w-[140px]">
                    {badge.text}
                  </span>
                </div>;
          })}
          </div>
          
        </div>
      </div>
    </section>;
}